import { authedFetch } from '@/lib/api-client'
import type { AdminUser, AuthSessionResponse } from './types'

// Thin wrappers around the endpoints documented in /specs/api.md. The server
// for these is being built in parallel; during local dev without a backend
// these will surface a NETWORK_ERROR via authedFetch, which the login flow
// handles with a friendly message.

export async function postAuthSession(idToken: string): Promise<AuthSessionResponse> {
  return authedFetch<AuthSessionResponse>('/auth/session', {
    method: 'POST',
    body: { idToken },
    skipAuth: true,
  })
}

export async function getUsersMe(): Promise<AdminUser> {
  return authedFetch<AdminUser>('/users/me', { method: 'GET' })
}
